












export default {
  name: 'IconToggleButton'

  props: [
    'id'
    'iconToggleUp'
    'iconToggleDown'
    'disabled'
  ]
  data: () ->
    toggle: false
  methods:
    clicked: ()->
      if not @disabled
        @toggle = !@toggle
        @$emit 'clicked', @toggle
  mounted: () ->
    componentHandler.upgradeElements @$el
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/elements/IconToggleButton.vue